/* eslint-disable react/prop-types */ // TODO: add props
import {
  UnsupportedQuestionType,
  name,
  answeredCorrectly,
} from '../../../components';
import { TextQuestionReview } from '../TextQuestionReview';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import { CorrectableQuestionReview } from '../CorrectableQuestionReview';
import { ComplexSolutionQuestionReview } from '../../../QuestionSetReview/components/CorrectableQuestionReview';

export const QuestionTypeSelection = ({
  question,
  solution,
  responses,
  classStudentProfiles,
  highlightProfileId,
  studentCourseProgUrl,
  emInsights,
}) => {
  const questionType = question.get('question_type');

  switch (questionType) {
    case EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE: {
      return (
        <CorrectableQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          classStudentProfiles={classStudentProfiles}
          nameColumn={name(studentCourseProgUrl)}
          studentResponseColumnSpec={{
            id: 'studentResponse',
            Header: 'Student Response',
            style: { width: '20%' },
            accessor: (row) => row.get('answer') || '',
            sortType: 'alphanumeric',
          }}
          answeredCorrectlyColumn={{
            ...answeredCorrectly,
            style: { width: '22%' },
          }}
          showChart
          showCorrectness
        />
      );
    }
    case EXAM_QUESTION_TYPES.TEXT: {
      return (
        <TextQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          getStudentCourseProgressUrl={studentCourseProgUrl}
          classStudentProfiles={classStudentProfiles}
          emInsights={emInsights}
        />
      );
    }
    case EXAM_QUESTION_TYPES.COMPLEX: {
      return (
        <ComplexSolutionQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          studentCourseProgUrl={studentCourseProgUrl}
          classStudentProfiles={classStudentProfiles}
        />
      );
    }
    default:
      return <UnsupportedQuestionType />;
  }
};
